import React from 'react'
import { Row, Col, Card } from 'antd'
import {
  PieChart,
  Pie,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts'
import { COLORS } from '../InventoryItems/utils/constants'

const InventoryCharts = ({ categoryData, valueTrendData }) => {
  // Chart colors
  const CHART_COLORS = [
    '#1890ff',
    '#13c2c2',
    '#52c41a',
    '#faad14',
    '#f5222d',
    '#722ed1',
    '#eb2f96',
    '#fa8c16',
    '#a0d911',
    '#fadb14'
  ]

  return (
    <Row gutter={[16, 16]} className='charts-row'>
      <Col xs={24} lg={12}>
        <Card className='chart-container'>
          <div className='chart-title'>
            <span>Inventory by Category</span>
          </div>
          <ResponsiveContainer width='100%' height={300}>
            <PieChart>
              <Pie
                data={categoryData}
                dataKey='value'
                nameKey='name'
                cx='50%'
                cy='50%'
                outerRadius={100}
                fill='#8884d8'
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {categoryData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => [`${value} items`, 'Count']} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card className='chart-container'>
          <div className='chart-title'>
            <span>Inventory Value Trend</span>
          </div>
          <ResponsiveContainer width='100%' height={300}>
            <LineChart data={valueTrendData}>
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='name' />
              <YAxis
                tickFormatter={(value) =>
                  `${value.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })}`
                }
              />
              <Tooltip
                formatter={(value) => [
                  value.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                  }),
                  'Inventory Value'
                ]}
              />
              <Legend />
              <Line
                type='monotone'
                dataKey='value'
                stroke={COLORS.PRIMARY}
                activeDot={{ r: 8 }}
                name='Inventory Value'
              />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </Col>
    </Row>
  )
}

export default InventoryCharts
